import { identity, isEmpty } from 'lodash';

import { SearchInstanceDto } from '@app/components/Search';

import { MetadataItem } from '../RecordMetadata';

export const formatInstanceMetadata = (
  instance: SearchInstanceDto,
  metadataItemConfigs: {
    title?: string;
    testId?: string;
    shouldRender?: boolean;
    getData: (value: SearchInstanceDto) => unknown;
    formatter?: (value) => void;
  }[]
) =>
  metadataItemConfigs.reduce<MetadataItem[]>(
    (
      formattedMetadata,
      { title, formatter, testId, getData, shouldRender = true }
    ) => {
      const data = getData(instance);

      if (shouldRender && !isEmpty(data)) {
        formattedMetadata.push({
          title,
          content: (formatter ?? identity)(data),
          testId,
        });
      }

      return formattedMetadata;
    },
    []
  );
